import { addDays, endOfDay, format, startOfDay } from 'date-fns';

const isoDateWithoutTimezoneRegex =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

export const defaultDateFilter = (days = 30) => ({
    id: 'createdAt',
    value: {
        dateFrom: startOfDay(addDays(Date.now(), -days)),
        dateTo: endOfDay(Date.now()),
    },
    isDefault: true,
});

export const operationsDateFilter = () => ({
    id: 'createdAt',
    value: {
        dateFrom: startOfDay(Date.now()),
        dateTo: endOfDay(Date.now()),
    },
    isDefault: true,
});

export const voiceOperationsDateFilter = () => ({
    id: 'createdAt',
    value: {
        dateFrom: new Date(addDays(Date.now(), -7)),
        dateTo: endOfDay(Date.now()),
    },
});

export const flagIndicatorsDateFilter = () => ({
    id: 'createdAt',
    value: {
        dateFrom: new Date(addDays(Date.now(), -90)),
        dateTo: endOfDay(Date.now()),
    },
});

export interface DateRange {
    from?: Date;
    to?: Date;
}

export function formatedDateHourForVoiceHistory(
    date: Date | string | undefined,
): string {
    if (!date) return '';
    const normalized = date instanceof Date ? date : new Date(date);
    return format(normalized, 'P - p');
}

export function normalizeUtcDateInput(date: string): string {
    return isoDateWithoutTimezoneRegex.test(date) ? `${date}Z` : date;
}

export function formatDateHour(date: Date | string | undefined): string {
    if (!date) return '';

    const isDate =
        date instanceof Date || (typeof date === 'object' && 'd' in date);

    const normalized = isDate ? date : new Date(date);
    return format(normalized, 'P - p');
}

export function formatUtcDateHour(date: Date | string | undefined): string {
    if (!date) return '';

    const isDate =
        date instanceof Date || (typeof date === 'object' && 'd' in date);

    const normalized = isDate
        ? date
        : new Date(normalizeUtcDateInput(date));

    return format(normalized, 'P - p');
}

export function formatDate(date: Date): string {
    return format(date, 'P');
}

export function isValid(date?: Date | string): date is Date | string {
    // eslint-disable-next-line no-restricted-globals
    return !!(date && date instanceof Date && !isNaN(date.valueOf()));
}
